export class UserModel {
  user: string;
  role: string;
  languageCode: string;
  token: string;
  lastLogin: string;
  environment: string;
  email: string;
  rows?: string;
  constructor(user: UserModel) {
    Object.assign(this, user);
    // Format the last login date and guard against null values
    this.lastLogin = this.lastLogin?.replace('T', ' ');
  }
}
